export default {
    title: '대기실',

    menu: {
        starDraw: '별 뽑기',
        seedLetter: '씨앗글자',
        recentResult: {
            label: '최근 수업 결과',
            short: '최근<br/>수업 결과',
        },
    },

    studentInfo: {
        gradeFormat: '{grade}학년',
        logoutConfirm: {
            title: '로그아웃',
            message: '로그아웃 할까요?',
        },
    },

    navigation: {
        toAvatars: '별 뽑기로 이동',
        toSeedLetter: '씨앗글자로 이동',
        toRecentResult: '최근 수업 결과로 이동',
    },
};
